export default __webpack_public_path__ + "static/media/nutritionfacts@3x.eb0dcbda.jpg";